import { CensusValidationPanel } from "@platform/census-validation";
import { CENSUS_VALIDATION_PAGE } from "@platform/feature-flags";
import { FeatureFlagBoundary } from "@platform/fe-utils";
import { useOutletContext, useParams } from "react-router";

import WorkbenchCensus from "./workbenchCensus";

/**
 * The Census tab.
 *
 * Behind the flag it reports what census processing made of the census the
 * broker sent. Without it, the census tool an analyst uses today.
 */
function CensusTab(): React.JSX.Element {
  const { id } = useParams();
  const { clientName } = useOutletContext<{ clientName?: string }>();

  return (
    <FeatureFlagBoundary
      flag={CENSUS_VALIDATION_PAGE}
      fallback={<WorkbenchCensus />}
    >
      <CensusValidationPanel rfpId={id ?? ""} clientName={clientName} />
    </FeatureFlagBoundary>
  );
}

export default CensusTab;
